import React from "react";
import { Link } from "react-router-dom";
import allblogsdata from "../data/blogsdata";
import BlogsCard from "./BlogsCard";

const Blogs = ({ more }) => {
	const mainblogs = allblogsdata.slice(0, 3);
	return (
		<div className="pb-5  bg-dark text-white">
			<h3 className="text-center mb-5">Some of my Blogs</h3>
			{more !== true && (
				<Link to="/blogs">
					<h4 className="text-decoration-none text-white text-right mx-3">
            See more
					</h4>
				</Link>
			)}
			{more ? (
				<div className=" row">
					{allblogsdata.map((blogdata) => (
						<BlogsCard blogdata={blogdata} key={blogdata.link} />
					))}
				</div>
			) : (
				<div className=" row">
					{mainblogs.map((blogdata) => (
						<BlogsCard blogdata={blogdata}  key={blogdata.link} />
					))}
				</div>
			)}
		</div>
	);
};

export default Blogs;
